function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as Yup from "yup";
import parseNumber from "./parseNumber";

/**
 * Note: this function is bound to a `Yup` schema when used, so `this.isType` is evaluated in that context.
 * Reference: https://github.com/jquense/yup#mixedtransformcurrentvalue-any-originalvalue-any--any-schema
 *
 * @param  {number | NaN | null} value the current cast value from the schema
 * @param  {String} originalValue the initial value from the input
 * @returns {number} the parsed value
 */
var numberFormatTransform = function numberFormatTransform(value, originalValue) {
  // eslint-disable-next-line no-invalid-this
  return this.isType(value) ? value : parseNumber(originalValue);
};

/**
 * @returns {Object} Yup validation object
 */
var buildNumberFromTextSchema = function buildNumberFromTextSchema() {
  return Yup.number().transform(numberFormatTransform).typeError("Must be a number!");
};

/**
 * @param  {HTMLElement} inputField  HTML Input element
 * @returns {boolean} if the field has a min/max attribute
 */
var isNumericField = function isNumericField(inputField) {
  return inputField.hasAttribute("min") || inputField.hasAttribute("max");
};

/**
 * @param  {HTMLElement} inputField  HTML Input element
 * @returns {Object} Yup validation object
 */
var buildValidationSchema = function buildValidationSchema(inputField) {
  var validation = {
    checkbox: Yup.array(),
    radio: Yup.string(),
    number: Yup.number()
  }[inputField.type];
  if (!validation) {
    if (isNumericField(inputField)) {
      validation = buildNumberFromTextSchema(inputField);
    } else {
      validation = Yup.mixed();
    }
  }
  if (inputField.hasAttribute("required")) {
    validation = validation.required("Answer required!");
  }
  if (inputField.hasAttribute("min")) {
    validation = validation.min(inputField.getAttribute("min"), "Too low!");
  }
  if (inputField.hasAttribute("max")) {
    validation = validation.max(inputField.getAttribute("max"), "Too high!");
  }
  return validation;
};

/**
 * @param  {Object} inputField HTML Input element
 * @returns {Object} Yup validation object
 */
var validate = function validate(inputField) {
  return _defineProperty({}, inputField.name, buildValidationSchema(inputField));
};
export default validate;